import React, { useEffect } from 'react';
import AmritjalNavbar from '../../components/Amritjal_hp/AmritjalNavbar';
// import AmritjalHero from '../../components/Amritjal_hp/AmritjalHero';
import AmritjalFooter from '../../components/Amritjal_hp/AmritjalFooter';
import AmritjalAbout from '../../components/Amritjal_hp/AmritjalAbout';
import AmritjalFeature from '../../components/Amritjal_hp/AmritjalFeature';
import bg1 from '../../assets/amritjal_hp/feature_bg1.png';
import bg2 from '../../assets/amritjal_hp/feature_bg2.jpeg';
import bg3 from '../../assets/amritjal_hp/feature_bg3.jpeg';
import bg4 from "../../assets/holiprasad/prasadBox.png"
import icon1 from '../../assets/amritjal_hp/classFragrance.png';
import icon2 from '../../assets/amritjal_hp/roseFragrance.png';
import icon3 from '../../assets/amritjal_hp/feature_bg4.png';
import tripImage from "../../assets/amritjal_hp/hidden_gem_trip.png";
import HeroSection from '../../components/InflunencerHomepage/HeroSection';
import { usePostHog } from "posthog-js/react";
import WhatsAppSupport from '../../components/Support/WhatsAppSupport';
import Metadata from '../../components/metadata/MetaData';

//import  Lottie  from 'lottie-react';
//import animationData from '../../amritHomepage.json';

const AmritjalHomepage = () => {
  //const [isLoading, setIsLoading] = useState(true);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setIsLoading(false);
  //   }, 3000); 

  //   return () => clearTimeout(timer);
  // }, []);

  // if (isLoading) {
  //   return (
  //     <section style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f0f0f0' }}>
  //       <Lottie animationData={animationData} style={{ width: 300, height: 300 }} />
  //     </section>
  //   );
  // }
  const posthog = usePostHog();
  useEffect(() => {
      posthog.capture("$pageview");
    }, [posthog]);

  return (
    <div>
      <AmritjalNavbar />
      <WhatsAppSupport/>
      <Metadata
        description="Celebrate Holi with the divine blessings of Shri Krishna! Order sacred Vrindavan Holi Prasad and Banke Bihari Temple offerings online. The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Get Holi 2025 Prasad, Holi Prasad Boxes, and divine blessings delivered to your doorstep. Immerse yourself in Krishna’s love and joy this Holi with spiritual Holi rituals, puja offerings, and Braj Holi traditions from Mathura and Vrindavan."
        keywords="Vrindavan Holi Prasad, Online Prasad Booking, Banke Bihari Holi Prasad, Holi 2025 Prasad, Braj Holi Offerings, Krishna Temple Prasad, Mathura Holi Prasad, Divine Prasad Home Delivery, Holi Blessings, Radha Krishna Holi, Spiritual Holi Traditions, Gulaal Offerings, Holi Bhog, Holi Prasad Service, Order Prasad Online, Holi Rituals in Vrindavan, Holi Puja Offerings, Buy Banke Bihari Prasad Online, Order Banke Bihari Temple Prasad, Online Banke Bihari Prasad Delivery, Vrindavan Holi Prasad Online, Holi Prasad Box Online, Sacred Holi Prasad Delivery, Banke Bihari Holi Prasad Box, Vrindavan Temple Prasad Online, Online Prasad from Banke Bihari Mandir, Buy Vrindavan Prasad Online for Holi, Holi Festival Offerings from Vrindavan, Krishna Bhog Prasad Online, Temple Prasad Home Delivery for Holi, Authentic Vrindavan Prasad Box, Online Delivery of Holi Prasad in India, Holi Special Prasad from Vrindavan Temples, Order Sacred Prasad from Vrindavan Temples, Banke Bihari Mandir Holi Offerings Online, Holi Prasad Gift Box from Vrindavan, Vrindavan Devotional Prasad for Holi, Mathura Holi, Mathura Holi 2025, Mathura Holi Dates 2025, Vrindavan Holi 2025, Barsana Holi 2025, Mathura Vrindavan Holi 2025, Brij Holi, Barsana Holi, Nandgaon Holi, Gokul Holi, Mahavan Holi, Goverdhan Holi, Holi, Huranga Holi, Vrindavan Holi, Brindavan Holi, Mathura Holi Calendar, India Holi, Braj Holi 2025 Schedule, Mathura Holi Schedule 2025, Holi Schedule, Colorful Festival Mathura Vrindavan, Bankey Bihari Temple Holi, Krishna Janmabhoomi Temple Holi, Lathmar Holi, Barsana Lathmar Holi, Phoolan Holi, Holi Festival Braja, Holi Celebration in Vrindavan, Charity on Holi, Holi Rituals, Lord Krishna Holi, Spring Festival, Spiritual Holi Celebration, Holi Charity Significance, Vrindavan Holi Traditions, Colors of Holi, Holi in Braja, Vrindavan Festival, Holi Prayers, Holi in Braja Region, Vrindavan Holi Customs, Holi Dance and Music, Holi Festivities in Vrindavan, Holi Community Celebrations, Holi in the Birthplace of Krishna, Holi Devotional Activities, Holi Festival of Love, Charity and Holi, Holi Color Festival, Devotional Holi Celebration, Vrindavan Holi Atmosphere, Holi in the Land of Krishna, Holi Worship and Prayers, Phool Wali Holi, Radha Krishna Holi, Widow's Holi, Holi in Mathura, Holi Traditions, Laddu Mar Holi, Holika Dahan, Dhulandi Holi, Holi Celebrations in India, Braj Region Holi, Krishna Holi Festival, Unique Holi Traditions, Holi Rituals in Braj."
        ogTitle="Order Vrindavan Holi Prasad Online | Banke Bihari Temple Offerings for Holi 2025"
        ogDescription="Celebrate Holi with the divine blessings of Shri Krishna! Order sacred Vrindavan Holi Prasad and Banke Bihari Temple offerings online. The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Get Holi 2025 Prasad, Holi Prasad Boxes, and divine blessings delivered to your doorstep. Immerse yourself in Krishna’s love and joy this Holi with spiritual Holi rituals, puja offerings, and Braj Holi traditions from Mathura and Vrindavan."
        ogImage="https://d3vqmpzcil03dt.cloudfront.net/webite-assets/dharmik_logo.png"
        ogUrl="https://dharmikapp.in/dharmikx"
        canonicalUrl="https://dharmikapp.in/dharmikx"
        twitter="@dharmikapp"
        youtube="@dharmik_hindi"
        instagram="@dharmik_app"
        author="Dharmik App"
        publisher="Dharmik"
        datePublished="2025-03-08"
       />
      {/* <AmritjalHero /> */}
      <HeroSection/>
      <AmritjalAbout />
      <AmritjalFeature
        bg={bg1}
        icon={icon1}
        title="Amrit Jal Spray"
        content="Infused with the sacred waters of Ganga, Yamuna, and Saraswati, Amrit Jal Spray purifies your aura and uplifts your spirit. Charged with the cosmic energy of Maha Kumbh 2025, it promotes positivity and spiritual well-being. Experience divine vibrations in every drop."
        link="/dharmikx/product/amritjal-spray"
      />
       <AmritjalFeature
        bg={bg3}
        icon={icon2}
        title="Amrit Jal Spray"
        subtitle="Rose Fragrance"
        content="A unique blend of divinity and luxury, Perfume X Ganga Jal combines the sacred essence of Ganga Jal with enchanting modern fragrances. It’s more than a perfume—it's an aura of purity and elegance. Perfect for those seeking a touch of spirituality in their daily lives."
        link={"/dharmikx/product/amritjal-rose"}
      />
      <AmritjalFeature
        bg={bg2}
        icon={tripImage}
        title="The Soul Drifters: Journeys to Recharge & Explore"
        content="Discover the power of self-healing with our immersive Hidden Gem trips, designed to connect you with nature and your inner self. These spiritual journeys blend mindfulness, meditation, and sacred destinations to rejuvenate your soul. A transformative experience awaits."
        link={"/dharmikx/trip-to-hidden-gems"}
      />
      <AmritjalFeature
        bg={icon3}
        icon={bg4}
        title="Vrindavan Holi Prasad Box "
        // subtitle="Rose Fragrance"
        content="Celebrate Holi with the divine blessings of Shri Krishna! The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Immerse yourself in Krishna’s love and joy this Holi!"
        link={"/dharmikx/vindavan-holi-prasad-box"}
      />
      <AmritjalFooter />
    </div>
  );
};

export default AmritjalHomepage;
